import React, { ReactNode } from 'react';

import classNames from 'classnames';

interface StatInfoProps {
  label: ReactNode;
  value: ReactNode;
  className?: string;
}

const StatInfo = ({ className, label, value }: StatInfoProps) => {
  return (
    <p
      className={classNames(
        'flex justify-between items-center flex-wrap w-full max-w-full xl:max-w-[330px] px-5 py-3 bg-primary-50 text-sm font-semibold rounded-2xl',
        className,
      )}
      data-qa="magic-board-total-reward"
    >
      {label}
      <span className="text-secondary-700" data-qa="magic-board-total-reward-value">
        {value}
      </span>
    </p>
  );
};

export default StatInfo;
